/* Filters for Meeting/Appointment json dicts
 *
 * Used with calendars/schedules
 */

// MEETING SLOT
export const isMeetingSlot = (item) => {
    return Object.prototype.hasOwnProperty.call(item, 'available');
};


// MEETING
export const isMeetingConfirmed = (item) => {
    return (item.confirmed_at !== null) &&
    (item.deleted_at === null)
};

export const isMeetingSlotless = (item) => {
    if (isAppointment(item)) { return false; }
    if (isDeleted(item)) { return false; }
    return (!item.meeting_slot_id);
};


/* No Attendee == meeting with yourself == Private */
export const isMeetingPrivate = (item) => {
    // console.log("isMeetingPrivate?", item);
    if (isAppointment(item)) { return false; }
    if (isMeetingSlot(item)) { return false; }
    // return (item.attendee_id !== null)
    return (!item.attendee_id)
};

export const isPrivate = isMeetingPrivate;


export const isMeetingSlotted = (item) => {
    // console.log("Meeting:", item)
    if (isAppointment(item)) { return false; }
    // if (isDeleted(item)) { console.log("Deleted"); return false; }
    // if (isMeetingSlotless(item)) { console.log("Slotless"); return false; }
    // if (isMeetingPrivate(item)) { console.log("Private"); return false; }
    if (
        isDeleted(item) ||
        isMeetingSlotless(item) ||
        isMeetingPrivate(item)
    ) {
        // console.log("BadMeeting")
        return false;
    }
    // console.log("GOOOD")
    return true;
}

/** Unconfirmed meetings where the attendee_id is the receiving ATTENDEE, rather than the booker
 * 
 * @param {Object} item
 * @param {Number} attendee_id
 * @returns {boolean}
 */
export const isMeetingPendingAttendeeId = (item, attendee_id) => {
    if (item.flags) {
        return (item.flags == 'MI')
    }
    return (item.attendee_id == attendee_id) &&
    (item.confirmed_at === null) &&
    (item.deleted_at === null)
};

/** Unconfirmed meetings where the attendee_id is the BOOKER, rather than the attendee
 * 
 * @param {Object} item
 * @param {Number} booker_id
 * @returns {boolean}
 */
export const isMeetingPendingBookerId = (item, booker_id) => {
    if (item.flags) {
        return (item.flags == 'MO')
    }
    return (item.booker_id == booker_id) &&
    (item.confirmed_at === null) &&
    (item.deleted_at === null)
};


/* APPOINTMENT LOGIC
 * !track_id && !in_schedule == Hidden
 * !track_id && in_schedule == InSchedule
 * track_id  == InTrack
 */

export const trackKeyFromId = (trackId) => {
    return `track${trackId}`;
}

export const trackKey = (item) => {
    if (!isAppointment(item)) { return null; }
    return trackKeyFromId(item.track_id ?? 0);
    // if (item.track_id) { return `track${item.track_id}`;}
    // return 'track0';
};


/** Iterate through a list of Appointments(?) and return all the track names 
 * 
 * @param {Array} items
 * @returns {Set}
 */
export const findTrackNames = (items) => {
    let _names = new Set();
    items.forEach(item => {
        if (item.track_name) {
            _names.add(item);
        }
    });
    return _names;
};

/** Is this item an Appointment? 
 * Appointments MUST have a track_id field (But it may be null).
 * 
 * @param {Object} item
 * @returns {boolean}
 */
export const isAppointment = (item) => {
    return Object.prototype.hasOwnProperty.call(item, 'track_id');
};

export const isAppointmentPinned = (item) => {
    if (!isAppointment(item)) { return false; }

    return item.in_schedule;
};

/** Is Hidden? This may be less important than what the Appointment actually _is_.
 * 
 * @param {Object} item
 * @returns {boolean}
 */
 export const isAppointmentHidden = (item) => {
    return ( (!item.in_schedule) && (!item.track_id));
};

/** Is this Appointment on the 'main' track? i.e. No track_id specified
 * 
 * TODO: If there is a ticket attached (for the current attendee), it also qualifies for Main Track, 
 * 
 * @param {Object} item
 * @returns {boolean}
 */
export const isTrack0 = (item) => {
    if (!isAppointment(item)) { return false; }

    return (
        // (item.in_schedule) &&
        (! item.track_id)
    );
};

export const isTrackId = (item, trackId) => {
    if (!isAppointment(item)) { return false; }

    return (
        item.track_id == trackId
    )
}

export const isTicketed = (item) => {
    if (!isAppointment(item)) { return false; }

    return Object.prototype.hasOwnProperty.call(item, 'appointment_attendees');
}


// GENERAL

/* isDeleted works on Meetings _and_ Appointments
 */
export const isDeleted = (item) => {
    if (! Object.prototype.hasOwnProperty.call(item, 'deleted_at')) { return false; }
    return (item.deleted_at !== null)
};


/* Is this a valid meeting, a ticketed appointment, or a pinned appointment (appointment.is_schedule=true)?
 * @param {Object} item
 * @returns {boolean}
 */
export const isInSchedule = (item) => {
    return (
        isTicketed(item) ||
        isAppointmentPinned(item) ||
        isMeetingSlotted(item)
    );
};

/* Is this a valid meeting (with a time) or a ticketed appointment?
 * @param {Object} item
 * @returns {boolean}
 */
export const isInItinerary = (item) => {
    return (
        isTicketed(item) ||
        isMeetingSlotted(item)
    );
};


/** Build the string of class names for an (Appointment) item
 * @param {Object} item - Appointment object
 * @returns {string} - class names
 */
 export const itemToClass = (item) => {
    if (isAppointment(item)) {
        if (isTrack0(item)) {
            return `track0`;
        } else {
            return `track-id${item.track_id} track${item.track_order}`;
        }
    }
    return '';
};


export const Filter = {
    isPrivate,
    isMeetingSlotless,
    isMeetingConfirmed,
    isMeetingPendingAttendeeId,
    isMeetingPendingBookerId,
    isDeleted,
    isAppointment,
    isTrack0,
    isTicketed,
    itemToClass,
};

// FILTERS
export const FILTERS = {
    // Meeting
    CONFIRMED: 'confirmed',
    INBOUND: 'inbound',
    OUTBOUND: 'outbound',
    CANCELLED: 'cancelled',
    // Appointment
    TICKETED: 'ticketed',
    TRACK_MAIN: 'track0', // Could be folded into track logic if we map Null => 0 ?
    TRACK: 'track',  // Base for trackname = `track${track.id}`
}

export const FILTER_ONLY = 'only';

// Default values for Calendar filters
export const DEFAULTS = {
    confirmed: true,
    inbound: true,
    outbound: true,
    cancelled: false,
    ticketed: true,
    track0: true,
    only: false,
};

// Turn everything off if there's an 'only=' value
export const DEFAULTS_ONLY = {
    confirmed: false,
    inbound: false,
    outbound: false,
    cancelled: false,
    ticketed: false,
    track0: false,
    only: false,
};

/** Merge the router params with the DEFAULTS, taking `only=` into account.
 * 
 * @param {Object} query
 * @returns {Object}
 */
export const buildQueryDefaults = (query) => {
    let _query = {};

    // console.log("buildQueryDefaults", query);
    // Short-circuit if 'only' is truthy
    if (query[FILTER_ONLY]) {
        _query = Object.assign({}, DEFAULTS_ONLY);
        // console.log("buildQueryDefaults:ONLY", _query);
        if (Array.isArray(query[FILTER_ONLY])) {
            query[FILTER_ONLY].forEach(only => {
                _query[only] = true;
            });
        } else {
            _query[query[FILTER_ONLY]] = true;
        }
    } else {
        _query = Object.assign({}, DEFAULTS);
        // console.log("buildQueryDefaults:Defaults", _query);
        Object.keys(query).forEach(key => {
            _query[key] = Number(query[key]);
            // console.log(`buildQueryDefaults: ${key} : ${_query[key]}`);
        });
    }

    // console.log("buildQueryDefaults:Returning", _query);
    return _query; 
}

/** Generate a set of tracknames for the filters
 * 
 * @param {OBject[]} tracks
 * @returns {String[]} - List of trackname strings
 */
export const buildQueryTracks = (tracks) => {
    return tracks.map(track => `track${track.id}`);
};

/** Build a new set of displayable params that only shows the non-default fields
 * 
 * @param {Object} query
 * @returns {Object}
 */
export const buildQueryDiff = (query) => {
    let _query = {};
    Object.keys(query).forEach(key => {
        if (key!='only') { // Remove 'only' field if changing the queryset
            _query[key] = query[key] ? 1 : 0;
            // if (query[key] != DEFAULTS[key]) {
            //     // console.log(`Setting ${key} to ${query[key]}`);
            //     _query[key] = query[key] ? 1 : 0;
            // }
        }
    });
    return _query;
};

/** Look at the set of query values passed in, and return a list of filters to apply
 * 
 * @param {Object} query - query object is destroyed while processing
 * @returns {List}
 */
export const loadFilters = (query) => {
    let _query = Object.assign({}, query);
    //let _out = [];
    let _out = [isAppointmentPinned]; // ALWAYS INCLUDE THE PINNED ITEMS

    // if (_query.private) {
    //     _out.push(isPrivate);
    // }
    // delete _query.private;

    // if (_query.slotless) {
    //     _out.push(isMeetingSlotless);
    // }
    // delete _query.slotless;

    if (_query.confirmed) {
        _out.push(isMeetingConfirmed);
    }
    delete _query.confirmed;

    if (_query.inbound) {
        _out.push(isMeetingPendingAttendeeId); // Requires attendee_id
    }
    delete _query.inbound;

    if (_query.outbound) {
        _out.push(isMeetingPendingBookerId); // Requires attendee_id
    }
    delete _query.outbound;

    // if (_query.deleted) {
    //     _out.push(isDeleted); // Could match deleted Appointments, but they should never be sent.
    // }
    // delete _query.cancelled;

    if (_query.ticketed) {
        _out.push(isTicketed); // Appointments with a ticket i.e. appointment_attendees entry
    }
    delete _query.ticketed;

    if (_query.track0) {
        _out.push(isTrack0); // 
    }
    delete _query.track0;

    console.log(`loadFilters: ${_query}`, _query);
    // Look for other tracks
    Object.keys(_query).forEach(key => {
        if (key.substring(0,5) == 'track') {
            if (_query[key]) { // Only enable the filter if truthy
                let trackId = Number(key.substring(5));
                // Wrap with anon function to preserve trackId
                _out.push( (item) => { return isTrackId(item, trackId);} )
            }
        }
    });
    return _out;
}